import React from 'react';
import MedicineList from './MedicineList';
import MedicalDevicesList from './MedicalDevicesList';
import SideNav from '../SideNav';
import { saveParams } from '../../../actions/noticeActions';
import { connect } from 'react-redux';


class FilingInfo extends React.Component {
    state = {
        searchParams: {},
        chooseType: 'medicine',
    }

    componentDidMount() {
        const { params = {} } = this.props;
        this.setState({
            searchParams:{
                ...params,
            },
        })
    }

    componentWillUnmount() {
        this.props.saveParams({ 
            compName: undefined,
        });
    }

    changeType = (chooseType) => {
        this.setState({ chooseType });
    }

    render() {
        const { chooseType, searchParams } = this.state;

        return (
            <div className="content">
                <SideNav selectKey="filingInfo" />
                <div className="main">
                    <div className="full home">
                        <div className='change-btn' style={{ marginBottom: 30 }}>
                            <a className={chooseType == "medicine" ? 'cur' : ''} onClick={() => { this.changeType('medicine') }} >药物</a>
                            <a className={chooseType == "medicalDevices" ? 'cur' : ''} onClick={() => { this.changeType('medicalDevices') }} >医疗器械</a>
                        </div>
                        {
                            chooseType == "medicine" ? 
                                <MedicineList searchParams={searchParams}/> 
                                : 
                                <MedicalDevicesList />
                        }
                    </div>
                </div>
            </div>
            
        );
    }
}

const mapStateToProps = (state, props) => {
    return {
        params: state.noticeState.params,
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        saveParams: (params) => dispatch(saveParams(params)),
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(FilingInfo);


// WEBPACK FOOTER //
// ./src/components/hospital/filingInfo/index.js